import React, { Component } from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faExclamationTriangle } from '@fortawesome/free-solid-svg-icons';
import { Container, Row, Col } from 'reactstrap';

class ErrorIndicator extends Component {
    render() {
        return (
            <Container>
                <Row>
                    <Col className="py-3 text-center">
                        <FontAwesomeIcon icon={faExclamationTriangle} size="4x" className="secondary-color" /><br />
                        <p className="text-color">{this.props.text}</p>
                    </Col>
                </Row>
            </Container>
        );
    }
}

export default ErrorIndicator;
